import template from './swag-cms-extensions-form-editor-settings-field-type-checkbox.html.twig';

export default {
    template,
    computed: {
        defaultValue: {
            set(newDefault) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                    this.field.id,
                    'default',
                    newDefault,
                );
            },
            get() {
                return this.field?.translated?.config?.default ?? this.field?.config?.default ?? false;
            },
        },
        values() {
            return [
                {
                    value: true,
                    label: this.$tc(
                        'swag-cms-extensions.sw-cms.components.form-editor.settings-field.defaultValues.checked',
                    ),
                },
                {
                    value: false,
                    label: this.$tc(
                        'swag-cms-extensions.sw-cms.components.form-editor.settings-field.defaultValues.notChecked',
                    ),
                },
            ];
        },
    },
}
